<!-- <div class="unauth-message"> -->

<div class="row mx-0 justify-content-center h-100 w-100 position-absolute">
	<form [formGroup]="accessRequestForm" class="m-auto">
		<!-- <div class="spacer"></div> -->
	<div class="cl-access-denied">
		<div class="cl-knock-first">
			<h1>KNOCK!</h1>
		</div>
		<div class="cl-knock-second">
			<h1>KNOCK!</h1>
		</div>
		<div class="cl-door-box">
			<div class="cl-door-shadow">
			</div>
			<div class="cl-door">
				<div class="cl-window-shadow">
				</div>
				<div class="cl-window">
					<div class="cl-window-guard">
						<div class="cl-window-guard-left-eye">
						</div>
						<div class="cl-window-guard-right-eye">
						</div>
						<div class="cl-window-guard-glasses">
						</div>
					</div>
					<div class="cl-window-slider">
						<div class="cl-window-handle">
						</div>
					</div>
				</div>
				<div class="cl-lock-ensamble">
					<div class="cl-lock-ensamble-handle">
					</div>
					<div class="cl-lock-ensamble-keyhole">
					</div>
				</div>
				<div class="cl-door-bottom-box">
					<div class="cl-door-bottom1 cl-door-bottom1-shadow">
					</div>
					<div class="cl-door-bottom1">
					</div>
					<div class="cl-door-bottom1 cl-door-bottom2-shadow">
					</div>
					<div class="cl-door-bottom2">
					</div>
					<div class="cl-door-bottom1 cl-door-bottom3-shadow">
					</div>
					<div class="cl-door-bottom3">
					</div>
					<div class="cl-door-bottom-screw-top-left">
					</div>
					<div class="cl-door-bottom-screw-top-right">
					</div>
					<div class="cl-door-bottom-screw-bottom-left">
					</div>
					<div class="cl-door-bottom-screw-bottom-right">
					</div>
				</div>
			</div>
		</div>
		<div class="cl-alert-message">
			<div class=" mx-0 mb-2 w-100">
			<div class="col-4 cl-bubble d-inline-block">
				<mat-icon class="lock">lock</mat-icon>
				<!-- <div class="cl-lock-top">
				</div>
				<div class="cl-lock-top-shadow">
				</div>
				<div class="cl-lock-bottom">
					<div class="cl-lock-bottom-shadow1">
					</div>
					<div class="cl-lock-bottom-shadow2">
					</div>
					<div class="cl-lock-bottom-keyhole-top">
					</div>
					<div class="cl-lock-bottom-keyhole-bottom">
					</div>
				</div> -->
			</div>
			<div class="mt-3 ml-5" style="width: 396px;">
				<h1 class="d-inline-block mt-0 ml-5">ACCESS DENIED!</h1>
			</div>
			</div>
			<div class="pl-4 mt-4" style="text-align: justify;">
				<p class="mb-0" style="color: rgb(190, 191, 192);">
					You do not have permission to access Supplier Gateway application.
				</p>
				<p class="mb-0" style="color: rgb(190, 191, 192);">
					To request access, please type a business justification below and submit your request
				</p>
				<div class="row mx-0 custom-space pl-2" style="color: rgb(190, 191, 192);">
					
					<label class="col-form-label d-block font-weight-normal">Business Justification</label>
					<mat-form-field appearance="outline" class="w-100">
						<textarea matInput rows="4" formControlName="businessJustification" id="businessJustification"></textarea>
					<mat-error class="pl-0" *ngIf="accessRequestForm.invalid">Minimum 3 characters required.</mat-error>
					</mat-form-field>
					</div>
					<div class="row mx-0 pl-2" >
						<button [disabled]="accessRequestForm.invalid || accessRequestForm.controls.businessJustification.value.length < 3" mat-raised-button class="mat-primary mat-raised-button sg-primary-button" (click)="submitAccessRequest()">Request Access</button>
					</div>
						<div class="row mx-0 pl-2">
							{{message}}
						</div>
			</div>
		</div>
	</div>
</form>
</div>
<!-- </div> -->